<!-- <app-header></app-header> -->
<div id="contentBox">
    <router-outlet></router-outlet>
</div>
<!-- <div [loaderModal]="loaderModalSettings"></div> -->
<!-- <app-footer></app-footer> -->
<!-- <div [messageModal]="messageModalSettings"></div> -->
